var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"pulseIframe",attrs:{"src":_vm.urlPulse(),"title":"Pulse","frameborder":"0","width":"100%","height":"100%"},on:{"load":_vm.onIframeLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }